var _filter, _filter2, _filter3, _g, _g2, _g3, _g4, _g5, _g6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGstr3B(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "documentGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#54AEDD",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#54AEDD",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#54AEDD",
      stopOpacity: 1
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "textGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#000000",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#1a1a1a",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "dropShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 4,
    dy: 8,
    stdDeviation: 6,
    floodColor: "#000000",
    floodOpacity: 0.15
  }))), _filter2 || (_filter2 = /*#__PURE__*/React.createElement("filter", {
    id: "textShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 2,
    dy: 3,
    stdDeviation: 2,
    floodColor: "#666666",
    floodOpacity: 0.3
  }))), _filter3 || (_filter3 = /*#__PURE__*/React.createElement("filter", {
    id: "innerShadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "offset-blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000000",
    floodOpacity: 0.1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "offset-blur",
    operator: "in"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8, 12)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "m490.6 230.4h-29.8v-53.5c0-3-0.6-6.1-1.8-8.9-1.2-2.8-2.9-5.4-5-7.6-2.2-2.1-4.8-3.8-7.6-5-2.8-1.2-5.9-1.8-8.9-1.8h-27.9v-20.6l-4.2-4.2-62.3-62.3-66.5-66.5h-208.3v93.9h-45c-3 0-6.1 0.6-8.9 1.8-2.8 1.1-5.4 2.8-7.6 5-2.1 2.2-3.8 4.7-5 7.6-1.2 2.8-1.8 5.8-1.8 8.9v372.8h0.1c-0.1 4.8 1.4 9.5 4.4 13.4q1.5 2 3.5 3.6 1.9 1.6 4.2 2.8q2.2 1.1 4.7 1.6q2.5 0.6 5 0.6h381.9c9.9 0 18.6-6.6 20.9-15.5l87.3-239.2v-1.5c0-14.7-9-25.4-21.4-25.4zm-53.1-59.7c3.4 0 6.2 2.8 6.2 6.2v53.5h-34.1v-59.7zm-352.2-153.6h179.2v128h128v85.3h-283.8q-1.9 0-3.7 0.3c-8.3 1.4-15.2 7.4-17.3 15.2l-2.4 6.6zm196.3 12l98.9 98.9h-98.9zm-264.5 88c0-3.4 2.8-6.2 6.2-6.2h45v188l-51.2 139.7zm391.4 374.2q-0.2 0.7-0.7 1.4-0.4 0.6-1 1.1-0.7 0.5-1.4 0.8-0.8 0.2-1.6 0.2h-381.9q-0.6 0-1.1-0.1-0.5-0.1-1-0.4-0.5-0.2-1-0.6-0.4-0.3-0.7-0.8c-0.6-0.7-1.4-2.2-1.1-3.5l51.3-140.5 35.5-97.3 0.2-0.7q0.2-0.8 0.7-1.4 0.4-0.7 1-1.2q0.7-0.4 1.4-0.7q0.8-0.3 1.6-0.3h381.9c3.2 0 4.1 4.7 4.3 7z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#dropShadow)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#documentGradient)",
    d: "m490.6 230.4h-29.8v-53.5c0-3-0.6-6.1-1.8-8.9-1.2-2.8-2.9-5.4-5-7.6-2.2-2.1-4.8-3.8-7.6-5-2.8-1.2-5.9-1.8-8.9-1.8h-27.9v-20.6l-4.2-4.2-62.3-62.3-66.5-66.5h-208.3v93.9h-45c-3 0-6.1 0.6-8.9 1.8-2.8 1.1-5.4 2.8-7.6 5-2.1 2.2-3.8 4.7-5 7.6-1.2 2.8-1.8 5.8-1.8 8.9v372.8h0.1c-0.1 4.8 1.4 9.5 4.4 13.4q1.5 2 3.5 3.6 1.9 1.6 4.2 2.8q2.2 1.1 4.7 1.6q2.5 0.6 5 0.6h381.9c9.9 0 18.6-6.6 20.9-15.5l87.3-239.2v-1.5c0-14.7-9-25.4-21.4-25.4zm-53.1-59.7c3.4 0 6.2 2.8 6.2 6.2v53.5h-34.1v-59.7zm-352.2-153.6h179.2v128h128v85.3h-283.8q-1.9 0-3.7 0.3c-8.3 1.4-15.2 7.4-17.3 15.2l-2.4 6.6zm196.3 12l98.9 98.9h-98.9zm-264.5 88c0-3.4 2.8-6.2 6.2-6.2h45v188l-51.2 139.7zm391.4 374.2q-0.2 0.7-0.7 1.4-0.4 0.6-1 1.1-0.7 0.5-1.4 0.8-0.8 0.2-1.6 0.2h-381.9q-0.6 0-1.1-0.1-0.5-0.1-1-0.4-0.5-0.2-1-0.6-0.4-0.3-0.7-0.8c-0.6-0.7-1.4-2.2-1.1-3.5l51.3-140.5 35.5-97.3 0.2-0.7q0.2-0.8 0.7-1.4 0.4-0.7 1-1.2q0.7-0.4 1.4-0.7q0.8-0.3 1.6-0.3h381.9c3.2 0 4.1 4.7 4.3 7z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0.8)",
    d: "m136.5 145.1h85.4c2.2 0 4.4-0.9 6-2.5 1.6-1.6 2.5-3.8 2.5-6.1 0-2.2-0.9-4.4-2.5-6-1.6-1.6-3.8-2.5-6-2.5h-85.4c-2.2 0-4.4 0.9-6 2.5-1.6 1.6-2.5 3.8-2.5 6 0 2.3 0.9 4.5 2.5 6.1 1.6 1.6 3.8 2.5 6 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0.8)",
    d: "m136.5 85.3h85.4c2.2 0 4.4-0.9 6-2.5 1.6-1.6 2.5-3.7 2.5-6 0-2.3-0.9-4.4-2.5-6-1.6-1.6-3.8-2.5-6-2.5h-85.4c-2.2 0-4.4 0.9-6 2.5-1.6 1.6-2.5 3.7-2.5 6 0 2.3 0.9 4.4 2.5 6 1.6 1.6 3.8 2.5 6 2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0.8)",
    d: "m136.5 204.8h204.8c2.3 0 4.5-0.9 6.1-2.5 1.6-1.6 2.5-3.8 2.5-6 0-2.3-0.9-4.5-2.5-6.1-1.6-1.6-3.8-2.5-6.1-2.5h-204.8c-2.2 0-4.4 0.9-6 2.5-1.6 1.6-2.5 3.8-2.5 6.1 0 2.2 0.9 4.4 2.5 6 1.6 1.6 3.8 2.5 6 2.5z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256, 350)",
    filter: "url(#textShadow)"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontFamily: "'Inter', 'Roboto', 'Segoe UI', sans-serif",
    fontWeight: 800,
    letterSpacing: "4px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0,
    fontSize: 64,
    fill: "url(#textGradient)"
  }, "GSTR"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 58,
    fontSize: 64,
    fill: "url(#textGradient)"
  }, "3B")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    fill: "rgba(255,255,255,0.6)",
    d: "M85.3 100.1h179.2v20c0 5-4 9-9 9H94.3c-5 0-9-4-9-9v-20z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 450,
    cy: 400,
    r: 8,
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 430,
    cy: 420,
    r: 4,
    fill: "rgba(255,255,255,0.3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGstr3B);
export default __webpack_public_path__ + "static/media/GSTR3B.833f71d416d204805484d89b7677c839.svg";
export { ForwardRef as ReactComponent };